module.exports = __webpack_public_path__ + "img/logo-coppertone.4e97fdfa.svg";